import { createSlice } from "@reduxjs/toolkit";

const initialIngredientState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  entitiesPreview: null,
  ingredientForEdit: undefined,
  lastError: null,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const ingredientSlice = createSlice({
  name: "Ingredient",
  initialState: initialIngredientState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    endCall: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.listLoading = false;
    },
    // get ingredient ById
    ingredientFetched: (state, action) => {
      state.actionsLoading = false;
      state.ingredientForEdit = action.payload.ingredientForEdit;
      state.error = null;
      state.actionsLoading = false;
    },
    // find ingredient
    ingredientsFetched: (state, action) => {
      const entities = action.payload.fridge_ingredients;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = action.payload.total;
      state.actionsLoading = false;
    },
    clearIngredients: (state, action) => {
      const entities = [];
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = 0;
      state.actionsLoading = false;
    },
    //
    ingredientsPreviewFetched: (state, action) => {
      const { entities } = action.payload;
      state.listLoading = false;
      state.actionsLoading = false;
      state.error = null;
      state.entitiesPreview = entities;
    },
    // create ingredient
    ingredientCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.ingredient);
    },
    // update ingredient
    ingredientUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map((entity) => {
        if (entity.id === action.payload.ingredient.id) {
          return action.payload.ingredient;
        }
        return entity;
      });
    },
    // delete ingredient
    ingredientDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.id !== action.payload.id
      );
    },
    // delete ingredient
    ingredientsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => !action.payload.ids.includes(el.id)
      );
    },
    // ingredientUpdateState
    ingredientStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map((entity) => {
        if (ids.findIndex((id) => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
  },
});
